import api from '../api'
/**
 * 管理员用户相关api
 */
export class RechargeApi extends api {
  /**
   * 充值
   * @param {*} form
   * @returns
   */
  recharge (form) {
    return this.request({
      url: `${this.servicePath}/${this.modulePath}/recharge`,
      method: 'post',
      data: form
    })
  }
  refund (form) {
    return this.request({
      url: `${this.servicePath}/${this.modulePath}/refund`,
      method: 'post',
      data: form
    })
  }
}

export default new RechargeApi('customerBalance')
